// src/sidebar/Sidebar.js
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, Calendar, Clock, Users, User, LayoutDashboard, LogOut } from 'lucide-react';
import SidebarLink from './SidebarLink';
import { useAuth } from '../contexts/AuthContext';
import { auth, signOut } from '../firebase';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleLogout = async () => {
    try {
      console.log("Attempting to sign out...");
      // Use the Firebase signOut directly to ensure it works
      await signOut(auth);
      console.log("Sign out successful");
      // Navigate after successful logout
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
      alert("Failed to sign out. Please try again.");
    }
  };

  const isRouteActive = (route) => {
    return location.pathname === route || location.pathname.startsWith(`${route}/`);
  };

  return (
    <aside className="fixed left-0 top-0 bottom-0 w-64 bg-[#2196f3] text-white z-10">
      <div className="p-6 h-full flex flex-col">
        {/* Logo and App Name */}
        <div className="flex items-center gap-2 mb-12">
          <BookOpen className="h-8 w-8" />
          <span className="text-2xl font-bold">StudyAce</span>
        </div>
        
        {/* User Email */}
        <div className="mb-8">
          <p className="text-sm opacity-80">Signed in as:</p>
          <p className="truncate">{currentUser?.email || 'Guest'}</p>
        </div>

        {/* Navigation Links */}
        <nav className="space-y-4 flex-1">
          <SidebarLink 
            icon={<LayoutDashboard className="h-6 w-6" />}
            to="/dashboard"
            isActive={location.pathname === '/dashboard'}
          >
            Dashboard
          </SidebarLink>
          
          <SidebarLink 
            icon={<User className="h-6 w-6" />}
            to="/profile"
            isActive={isRouteActive('/profile')}
          >
            Profile
          </SidebarLink>
          
          <SidebarLink 
            icon={<Calendar className="h-6 w-6" />}
            to="/timetable"
            isActive={isRouteActive('/timetable')}
          >
            Timetable
          </SidebarLink>
          
          <SidebarLink 
            icon={<Clock className="h-6 w-6" />}
            to="/study-timer"
            isActive={isRouteActive('/study-timer')}
          >
            Study Timer
          </SidebarLink>
          
          <SidebarLink 
            icon={<Users className="h-6 w-6" />}
            to="/study-group"
            isActive={isRouteActive('/study-group')}
          >
            Study Group
          </SidebarLink>
        </nav>

        {/* Logout Button */}
        <div className="mt-auto">
          <button 
            onClick={handleLogout} 
            className="flex items-center gap-3 text-white hover:bg-[#1e88e5] p-2 rounded-lg w-full text-left"
            aria-label="Logout"
          >
            <LogOut className="h-6 w-6" />
            <span className="text-lg">Logout</span>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;